import api from "./api";
import { ISettingsCategories } from "../modules/manager/settings/components/pricing";


export interface ISettingsCategoryService { 
    categories: ISettingsCategories[],
    is_base_price: boolean
}

export const saveConnectionCredentials = async(params?: any) => {
    const { data } = await api.post('/manager/integration/', params);
    
    return data;
}

export const updateConnectionCredentials = async(id: string, params?: any) => {
    const { data } = await api.put(`/manager/integration/${id}`, params);
    
    return data;
}

export const getConnectionCredentials = async () => { 
    const { data } = await api.get('/manager/integration/me');
    
    return data;
}

export const mediaCategory = async () => { 
    const { data } = await api.get<ISettingsCategoryService>('manager/media_category/settings/');
    
    return data;
}

export const updateMediaCategory = async (req: ISettingsCategoryService) => { 
    const { data } = await api.put<ISettingsCategoryService>('manager/media_category/settings/', req);
    
    return data;
}